//These universities have implemented the cookie consent manager on their site.
import * as URLParamHelpers from "./UrlUtils";

const universitiesWithCookieConsentManager = [
    "staffordshire-university",
    "brunel-university-london",
    "cphbusiness",
    "hec-paris",
    "zuyd",
    "uwe-bristol",
    "the-american-university-of-rome",
    "jacobs-university",
    "technical-university-of-denmark",
    "tu-delft",
    "university-of-groningen",
    "careers-personal-development-staffordshire",
    "university-of-strathclyde",
    "hec",
    "thomas-more-university-of-applied-sciences",
    "ecole-polytechnique",
    "arteveldehogeschool",
    "berlin-school-of-business-and-innovation",
];

export const getUniversitySlug = (urlPath) => {
    const url = new URL(urlPath);

    const widgetPath = new RegExp("^(\\/embed\\/|\\/pwa\\/)([^\\/]+).+");
    const buddyCardPath = new RegExp("^(\\/)([^\\/]+)\\/colour");
    const blogFeedPath = new RegExp("^(\\/)([^\\/]+)\\/blog");

    //chat bubble
    const uniSlug = URLParamHelpers.getParameterByName(url.href, "universitySlug");
    if (uniSlug) {
        return uniSlug;
    }

    //embedded widget or pwa
    let found = url.pathname.match(widgetPath);
    if (found && found.length >= 3) {
        return found[2];
    }

    //buddy card
    found = url.pathname.match(buddyCardPath);
    if (found && found.length >= 3) {
        return found[2];
    }

    //blog feed
    found = url.pathname.match(blogFeedPath);
    if (found && found.length >= 3) {
        return found[2];
    }

    return null;
};

export const checkUserCookieConsent = (urlPath) => {
    const uniSlug = getUniversitySlug(urlPath);

    if (!uniSlug) {
        return false;
    }
    return universitiesWithCookieConsentManager.includes(uniSlug);
};
